import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StrategiesComponent } from './strategies.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { StrategiesListResolve } from './services/strategies-list-resolve.service';
import { AuthGuardService } from '../auth/services/auth-guard.service';
import { PlanComponent } from './plan/plan.component';
import { StrategyIdResolve } from './services/strategy-id-resolve.service';
import { PlanTreeResolve } from './services/plan-tree-resolve.service';
import { PurposeMissionBeliefsResolve } from './services/purpose-mission-beliefs-resolve.service';
import { PlanCoordinateResolve } from './services/plan-coordinate-resolve.service';
import {SynthesizeResultsComponent} from './plan/envisioning/synthesize-results/synthesize-results.component';
import {CustomerChildrenResolveService} from './customer-children-resolve.service';

const routes: Routes = [
  {
    path: '',
    component: StrategiesComponent,
    canActivate: [
      AuthGuardService
    ],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }, {
        path: 'dashboard/:institutionId',
        component: DashboardComponent,
        resolve: {
          strategies: StrategiesListResolve,
          childInstitutions: CustomerChildrenResolveService
        }
      }
    ]
  },
  {
    path: ':strategyId',
    component: PlanComponent,
    canActivate: [
      AuthGuardService
    ],
    resolve: {
      strategyId: StrategyIdResolve,
      planTree: PlanTreeResolve,
      purposeMissionBeliefs: PurposeMissionBeliefsResolve,
      planCoordinate: PlanCoordinateResolve
    },
    children: [
      {
        path: '',
        redirectTo: 'envisioning',
        pathMatch: 'full'
      }, {
        path: 'envisioning',
        component: SynthesizeResultsComponent
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})

export class StrategiesRoutingModule { }
